export default __webpack_public_path__ + "static/media/comedy.536ab4c6.png";